import React from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
var GoogleMapWrapper = function (_a) {
    var apiKey = _a.apiKey, version = _a.version, libraries = _a.libraries, children = _a.children;
    return (React.createElement(Wrapper, { apiKey: apiKey, version: version, libraries: libraries }, children));
};
export default GoogleMapWrapper;
//# sourceMappingURL=GoogleMapWrapper.js.map